export default __webpack_public_path__ + "static/media/u-logo.76520efe.svg";